module.exports = __webpack_public_path__ + "img/banner-bio.73c95d1f.png";